/** Zeilenfarb-Marker der Bestellpositions-Spalten (`GetRowColorCssClass`). */

import type { OrderPosition } from '@/types/entities';

import { getOrderPositionRowColor } from '../rowColors';
import { RowColorMarker } from '../shared/RowColorMarker';

export interface OrderPositionRowColorProps {
  model: OrderPosition;
}

export function OrderPositionRowColor(props: OrderPositionRowColorProps) {
  return <RowColorMarker className={getOrderPositionRowColor(props.model)} />;
}

export default OrderPositionRowColor;
